import './App.css';
import {BrowserRouter  , Routes , Route} from 'react-router-dom';


/* pages */
import Home from './pages/Home';
import Games from './pages/Games';
import ErrorPage from './pages/ErrorPage';

import Rearrange from './pages/Rearrange';
import SimilarTo from './pages/SimilarTo';

 import Nav from './components/Nav';
import Dictionary from './pages/Dictionary';
import Learn from './pages/Learn';
import Favourites from './pages/Favourites';
import Footer from './components/Footer';


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Nav></Nav>
        <Routes>
          
          <Route path='/' element={<Home/>}></Route>

          <Route path='/learn' element={<Learn/>}></Route>
          <Route path='/games' element={<Games/>}></Route>
          <Route path='/games/rearrange' element={<Rearrange/>}></Route>
          <Route path='/games/similarto' element={<SimilarTo/>}></Route>

          <Route path='/dictionary' element={<Dictionary/>}></Route>
          <Route path='/favourites' element={<Favourites/>}></Route>

          <Route path='*' element={<ErrorPage/>}></Route>
        </Routes>
        <Footer></Footer>
      </BrowserRouter>
    </div>
  );
}

export default App;
